import { render, staticRenderFns } from "./search.vue?vue&type=template&id=b0e7a8bc&scoped=true"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"
import style0 from "./search.vue?vue&type=style&index=0&id=b0e7a8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e7a8bc",
  null
  
)

export default component.exports